import React, { useRef } from 'react';
import { useLanguage } from '../../../../../context/LanguageContext';
import wishlistBgImage from '../../../../../assets/logo/wishlist/wishlist_1.webp';
import '../style/wishlist.css';

const WishlistSection: React.FC = () => {
    const { t, language } = useLanguage();
    const containerRef = useRef<HTMLDivElement>(null);
    const translation = t as any;
    const wishlistTranslations = translation.WISHLIST || {};
    const navigationTranslations = translation.NAVIGATION || {};

    return (
        <>
            {/* Page Header */}
            <section className="page-header" style={{ 
                position: 'relative', 
                overflow: 'hidden',
                marginTop: 0,
                paddingTop: 0,
                marginBottom: 0,
                height: '380px'
            }}>
                <div
                    className="page-header__bg"
                    style={{
                        backgroundImage: `url(${wishlistBgImage})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center top',
                        backgroundRepeat: 'no-repeat',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        width: '100%',
                        height: '380px',
                        zIndex: 0
                    }}
                ></div>
                <div className="container" style={{ position: 'relative', zIndex: 1 }}>
                    <div className="page-header__inner">
                        <h1>{wishlistTranslations.title || (language === 'pt' ? 'Lista de Desejos' : 'Wishlist')}</h1>
                        <div className="thm-breadcrumb__inner">
                            <ul className="thm-breadcrumb list-unstyled">
                                <li><a href="/">{navigationTranslations.start || (language === 'pt' ? 'Início' : 'Home')}</a></li>
                                <li><span className="fas fa-angle-right"></span></li>
                                <li>{wishlistTranslations.title || (language === 'pt' ? 'Lista de Desejos' : 'Wishlist')}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            {/* Wishlist Page */}
            <section className="wishlist-page" ref={containerRef}>
                <div className="container">
                    {/* Desktop Table View */}
                    <div className="table-responsive">
                        <table className="table wishlist-table">
                            <thead>
                                <tr>
                                    <th>{wishlistTranslations.productName || (language === 'pt' ? 'Nome do Produto' : 'Product Name')}</th>
                                    <th>{wishlistTranslations.brand || (language === 'pt' ? 'Marca' : 'Brand')}</th>
                                    <th>{wishlistTranslations.stockStatus || (language === 'pt' ? 'Estado do Stock' : 'Stock Status')}</th>
                                    <th>{wishlistTranslations.action || (language === 'pt' ? 'Ação' : 'Action')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* Wishlist items will be populated dynamically by wishlist-firebase.js */}
                                <tr>
                                    <td colSpan={4} className="text-center">
                                        <div className="loading-message">
                                            <p>{wishlistTranslations.loading || (language === 'pt' ? 'A carregar lista de desejos...' : 'Loading wishlist...')}</p>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    
                    {/* Mobile Card View */}
                    <div className="wishlist-cards-container">
                        <div className="wishlist-cards-row">
                            {/* Wishlist cards will be populated dynamically by wishlist-firebase.js */}
                            <div className="loading-message">
                                <p>{wishlistTranslations.loading || (language === 'pt' ? 'A carregar lista de desejos...' : 'Loading wishlist...')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default WishlistSection;

